import {List, Map} from 'immutable';
import {api} from 'helpers/api';
import {success, error} from 'helpers/response';
import _ from 'lodash';

export const getDictionaryList = (key, meta = null) => async (dispatch) => {
    try {
        meta = meta || {
                order: {
                    column: 'name',
                    direction: 'asc',
                },
            };
        const response = _.isArray(key) ? await api.dictionary.getDictionaryLists(key, meta) : await api.dictionary.getDictionaryList(key, meta);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/dictionary.js